module.exports = __webpack_public_path__ + "img/daweo.da0dade1.png";